<script setup lang="ts">
import VideoCallMediaSettingsControl from "~/components/video-call/VideoCallMediaSettingsControl.vue";
import { useVideoCallsStore } from "~/stores/videoCalls";

withDefaults(
  defineProps<{
    overlay?: boolean;
  }>(),
  {
    overlay: false,
  },
);

const store = useVideoCallsStore();

const refreshDevices = () => {
  // eslint-disable-next-line no-void
  void store.refreshMediaDevices();
};

onMounted(() => {
  navigator.mediaDevices?.addEventListener?.("devicechange", refreshDevices);
});

onBeforeUnmount(() => {
  navigator.mediaDevices?.removeEventListener?.("devicechange", refreshDevices);
});
</script>

<template>
  <VideoCallMediaSettingsControl
    :overlay="overlay"
    :camera-devices="store.cameraDevices"
    :microphone-devices="store.microphoneDevices"
    :selected-camera-device-id="store.selectedCameraDeviceId"
    :selected-microphone-device-id="store.selectedMicrophoneDeviceId"
    :media-ready="store.mediaReady"
    :media-devices-status="store.mediaDevicesStatus"
    :media-devices-error="store.mediaDevicesError"
    :switching-device-kind="store.switchingDeviceKind"
    @opened="refreshDevices"
    @select-input-device="store.setInputDevice"
  />
</template>
